import React from "react";
import { SvgIcons } from "../../../SharedComponents/SvgIcons/SvgIcons";
import EmphasizedMessage from "../EmphasizedMessage";
import styles from "./BlockerList.module.css";

/**
 * Why the primary button is disabled, as a checklist: a bold warning heading that
 * counts what is left, then one line per gate with an info icon that explains, in
 * plain words, what the ops user has to do. A disabled button with no reason is
 * the complaint this exists to answer.
 *
 * @param {{ action: string,
 *           items: {key: string, label: string, help?: string}[] }} props
 *   `action` finishes the heading: "…before you can <action>".
 */
const BlockerList = ({ action, items }) => {
  if (!items?.length) return null;
  const count = items?.length;

  return (
    <div className={styles.box} role="status">
      <div className={styles.heading}>
        <SvgIcons name="exclamation_circle_filled" className={styles.headingIcon} width="20" height="20" />
        {count === 1 ? "1 thing" : `${count} things`} to finish before you can {action}
      </div>
      <ul className={styles.list}>
        {items?.map((item) => (
          <li key={item?.key} className={styles.item}>
            <span>
              <EmphasizedMessage text={item?.label} />
            </span>
            {item?.help && (
              <span className={styles.info}>
                <button
                  type="button"
                  className={styles.infoButton}
                  aria-label={`About: ${item?.label}`}
                  aria-describedby={`blocker-help-${item?.key}`}
                >
                  <SvgIcons name="info_circle" width="16" height="16" />
                </button>
                <span id={`blocker-help-${item?.key}`} role="tooltip" className={styles.tooltip}>
                  {item?.help}
                </span>
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BlockerList;
